import { useEffect } from 'react'
import { UserAvatarVariant } from '@/components/common/user/avatar.tsx'
import { useUserStore } from '@/store/user.ts'
import { useProjectStageStore } from '@/components/common/menu/lib/store/useProjectStageStore.tsx'
import { useQuery } from '@tanstack/react-query'

import { currStageUsersQuery } from '@/lib/actions/getCurrStageUsers.ts'
import { formatUserName } from '@/lib/helpers/formatUserName.ts'

/*
Compact bottom-of-drawer identity row. One line, left-aligned, avatar +
name with role as a muted subline underneath. Keeps the "who am I / which
role" info glanceable without eating vertical space that the nav itself
needs — the drawer sometimes has to fit ~8 groups + counts on short
devices.
*/
export default function NavUserData() {
  const userLogged = useUserStore(state => state.user)
  const projectStageId = useProjectStageStore(state => state.currProjectStage)?.id
  const resetStageStore = useProjectStageStore(state => state.resetStageStore)

  const { data: stageUsers, error: stageUsersError } = useQuery({
    ...currStageUsersQuery(projectStageId),
    enabled: !!projectStageId,
    throwOnError: false,
  })

  useEffect(() => {
    if (stageUsersError) {
      resetStageStore()
    }
  }, [stageUsersError, resetStageStore])
  const stageUser = stageUsers?.find(user => user.id === userLogged?.id)
  const userName = formatUserName(userLogged)
  const userRole = stageUser?.projectRole

  return (
    <div className={`flex min-w-0 flex-1 flex-row items-center gap-2`}>
      {userLogged?.avatar?.contentUrlSmall && (
        <UserAvatarVariant
          avatarUrl={userLogged?.avatar?.contentUrlSmall}
          size={'tiny'}
          user={userLogged}
        />
      )}
      <div className={`flex min-w-0 flex-col leading-tight`}>
        <span className={`truncate text-xs font-medium`}>
          {userName || userLogged?.email}
        </span>
        {userRole && (
          <span className={`truncate text-[11px] text-muted-foreground`}>{userRole}</span>
        )}
      </div>
    </div>
  )
}
